function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3E4C57",
  fillRule: "evenodd",
  d: "M8.503 0c.077 0 .151.03.206.085l2.333 2.334c.055.054.086.129.086.206v10.5c0 .483-.392.875-.875.875H.92c-.484 0-.875-.392-.875-.875V.875C.045.392.436 0 .92 0zm-.292.583H.92c-.161 0-.292.13-.292.292v12.25c0 .161.13.292.292.292h9.333c.161 0 .292-.13.292-.292V2.745L8.794.996v1.047c0 .138.097.253.225.284l.067.007h.584v.584h-.584c-.483 0-.875-.392-.875-.875V.583zm1.167 10.792v.583H1.795v-.583h7.583zm0-1.458v.583h-.583v-.583h.583zm-1.167 0v.583h-.583v-.583h.583zm-1.75 0v.583H1.795v-.583H6.46zm2.334-5.542c.322 0 .583.261.583.583v3.5c0 .322-.261.584-.583.584H2.378c-.322 0-.583-.262-.583-.584v-3.5c0-.322.26-.583.583-.583zm0 .583H2.378v3.5h6.417v-3.5zM2.378 2.917V3.5h-.583v-.583h.583zm1.167 0V3.5H2.96v-.583h.584zM4.71 1.75v.583H1.795V1.75H4.71z"
});

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.6fa6adee.svg";
export { ForwardRef as ReactComponent };